module.exports = __webpack_public_path__ + "static/img/carousel_4.950cfb61.jpg";